export default "__VITE_ASSET__C0a3L$0k__"